export default {
  namespaced: true,
  actions: {
    async get_all_TourAddons(_, { Authtoken, userCompany }) {
      try {
        const sessionUser = localStorage.getItem('user');
        const userType = JSON.parse(sessionUser).user.user_type;

        const API_URL = `${this.state.base_URL}tour-addons`;

        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Authtoken}`,
          'User-Company': userCompany,
          'User-Type': userType
        };

        const res = await fetch(API_URL, {
          method: 'GET',
          headers
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        throw new Error(error);
      }
    },

    async getTourAddonsInfo(_, { Authtoken, addonID }) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons/${addonID}`;

        const res = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`
          },
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },

    async create_TourAddons(_, dataToUpdate) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons`;
        let formData = new FormData();

        for (const key in dataToUpdate) {
          if (key !== 'token' && dataToUpdate[key] !== null) {
            formData.append(key, dataToUpdate[key]);
          }
        }

        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${dataToUpdate.token}`
          },
          body: formData
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },

    async update_TourAddons(_, dataToUpdate) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons/${dataToUpdate.addonID}`;
        let formData = new FormData();

        for (const key in dataToUpdate) {
          if (key !== 'token' && dataToUpdate[key] !== null) {
            formData.append(key, dataToUpdate[key]);
          }
        }

        formData.append('_method', 'PUT');

        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${dataToUpdate.token}`
          },
          body: formData
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },

    async deactivate_TourAddons(_, { Authtoken, addonID }) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons/${addonID}`;

        const res = await fetch(API_URL, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`
          },
          body: JSON.stringify({
            TourAddon_status: 2
          })
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },

    async activate_TourAddons(_, { Authtoken, addonID }) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons/${addonID}`;

        const res = await fetch(API_URL, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`
          },
          body: JSON.stringify({
            TourAddon_status: 1
          })
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },

    async delete_TourAddons(_, { Authtoken, addonID }) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons/${addonID}`;

        const res = await fetch(API_URL, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`
          },
          body: JSON.stringify({
            TourAddon_status: 3
          })
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },

    async delete_TourAddons_permanently(_, { Authtoken, addonID }) {
      try {
        const API_URL = `${this.state.base_URL}tour-addons/${addonID}`;

        const res = await fetch(API_URL, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Authtoken}`
          }
        });

        const response = await res.json();
        if ('errors' in response) return response.errors;
        return response;

      } catch (error) {
        console.error('Error during query:', error);
        throw new Error(error);
      }
    },
  }
};
